import { ImportActionType, ImportingAction } from "../actions/import.actions";

const initialState: any = {
    showImporting: false,
    showIcon: false,
    text: 'Verifying...',
    success: false,
    error:false
};

export function ImportReducer(
    state: any = initialState,
    action: ImportingAction
) {
    switch (action.type) {
        case ImportActionType.IMPORTING:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}